/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListItemsQueryResponse, TrimbleItemsControllerListItemsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListItems";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleItemsControllerListItems } from "../../clients/trimbleService/trimbleItemsControllerListItems";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleItemsControllerListItemsQueryKey = (params: TrimbleItemsControllerListItemsQueryParams) => [{
  url: '/api/v1/trimble/items'
}, ...(params ? [params] : [])] as const;
export type TrimbleItemsControllerListItemsQueryKey = ReturnType<typeof trimbleItemsControllerListItemsQueryKey>;
export function trimbleItemsControllerListItemsQueryOptions(params: TrimbleItemsControllerListItemsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleItemsControllerListItemsQueryKey(params);
  return queryOptions<TrimbleItemsControllerListItemsQueryResponse, ResponseErrorConfig<Error>, TrimbleItemsControllerListItemsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleItemsControllerListItems(params, config);
    }
  });
}

/**
 * @summary Browse Trimble sources, projects and folders
 * {@link /api/v1/trimble/items}
 */
export function useTrimbleItemsControllerListItems<TData = TrimbleItemsControllerListItemsQueryResponse, TQueryData = TrimbleItemsControllerListItemsQueryResponse, TQueryKey extends QueryKey = TrimbleItemsControllerListItemsQueryKey>(params: TrimbleItemsControllerListItemsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleItemsControllerListItemsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleItemsControllerListItemsQueryKey(params);
  const query = useQuery({
    ...trimbleItemsControllerListItemsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}